<!-- Mobile Menu -->
<mat-drawer-container class="mobile-drawer-container lang-{{currentLanguage}}">
  <mat-drawer #drawer mode="over" position="start" class="mobile-drawer">
    <div class="drawer-header">
      <img src="assets/logo/logo-blue.svg" alt="XEDOOM" class="drawer-title logo" width="140" height="28">
      <button mat-icon-button (click)="closeDrawer()" aria-label="Close menu">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <nav class="drawer-nav">
      @if (user) {
        <div class="section game">
          <a mat-button [routerLink]="langPart+'/playarea'" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }">
            {{ 'header.navigation.all-games' | translate | async }}
          </a>

          <mat-divider></mat-divider>
          <div class="section profile">
            @if (!currentSessionId) {
              <a mat-button (click)="openJoinGameDialog()">
                <mat-icon>group_add</mat-icon>
                {{ 'header.navigation.join-game' | translate | async }}
              </a>
            }
            @if (viewerMode === true) {
              <a mat-button [routerLink]="[langPart+'/playarea/room', currentSessionId]" aria-label="Game mode">
                <mat-icon>sports_esports</mat-icon>
                {{ 'header.navigation.back-to-game-mode' | translate | async }}
              </a>
            }
            @if (viewerMode === false) {
              <a mat-button [routerLink]="[langPart+'/playarea/room', currentSessionId, 'viewer']" aria-label="Viewer mode">
                <mat-icon>tv</mat-icon>
                {{ 'header.navigation.viewer-mode' | translate | async }}
              </a>
              <!-- <app-hint class="mobile" text="{{ 'hints.viewer_mode' | translate | async}}" hintId="4" arrowPosition="top" left="calc(50% - 10px)" top="5px" width="260px"></app-hint> -->
            }
            @if (currentSessionId) {
              @if (!isInRoom) {
                <a mat-button [routerLink]="[langPart+'/playarea/room', currentSessionId]" class="active-game-button" aria-label="Active Game">
                  <mat-icon class="mobile-icon">sports_esports</mat-icon>
                  <span class="no-mobile">{{ 'header.navigation.active-game' | translate | async }}</span>
                </a>
              }
              <a mat-button class="no-mobile" (click)="onLeaveSession()">
                <mat-icon>exit_to_app</mat-icon>
                {{ 'header.navigation.leave-game' | translate | async }}
              </a>
            }
          </div>
        </div>
        <mat-divider></mat-divider>
        <div class="section profile">
          <div class="account-header">
            <div class="account-info">
              <mat-icon>account_circle</mat-icon>
              <span>{{ user.name }}</span>
            </div>
          </div>
          <div class="tokens mobile">
            <mat-icon matTooltip="{{'game_tokens.tooltips.monthly_tokens' | translate | async}}" color="accent">token</mat-icon>
            <span class="value">{{(currentBalance$ | async)?.monthlyTokens}}</span>
            <mat-icon matTooltip="{{'game_tokens.tooltips.bonus_tokens' | translate | async}}" color="warn">diamond</mat-icon>
            <span class="value">{{(currentBalance$ | async)?.bonusTokens}}</span>
          </div>
          <a mat-button [routerLink]="langPart+'/profile/my-profile'" routerLinkActive="active-link" (click)="closeDrawer()">
            <mat-icon>person</mat-icon>
            {{ 'profile.menu.my_profile' | translate | async }}
          </a>
          <a mat-button [routerLink]="langPart+'/profile/my-teams'" routerLinkActive="active-link" (click)="closeDrawer()">
            <mat-icon>groups</mat-icon>
            {{ 'profile.menu.my_teams' | translate | async }}
          </a>
          <a mat-button [routerLink]="langPart+'/profile/my-games'" routerLinkActive="active-link" (click)="closeDrawer()">
            <mat-icon>videogame_asset</mat-icon>
            {{ 'profile.menu.my_games' | translate | async }}
          </a>
          <a mat-button [routerLink]="langPart+'/profile/quiz-ai'" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }">
            <mat-icon>quiz</mat-icon>
            {{ 'header.navigation.play-ai' | translate | async }}
          </a>
          <a mat-button [routerLink]="langPart+'/profile/games-played'" routerLinkActive="active-link" (click)="closeDrawer()">
            <mat-icon>history_edu</mat-icon>
            {{ 'profile.menu.games_played' | translate | async }}
          </a>
          <a href="#" mat-button (click)="onLogout()">
            <mat-icon>exit_to_app</mat-icon>
            {{ 'header.navigation.logout' | translate | async }}
          </a>
        </div>

        <mat-divider></mat-divider>
      }
        <div class="section public" [class.next-menu]="user">
          <a [routerLink]="langPart? langPart : '/'" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }" (click)="closeDrawer()">
            {{ 'header.navigation.home' | translate | async }}
          </a>
          <a [routerLink]="langPart+'/features'" routerLinkActive="active-link" (click)="closeDrawer()">
            {{ 'header.navigation.features' | translate | async }}
          </a>
          <a [routerLink]="langPart+'/news'" routerLinkActive="active-link" (click)="closeDrawer()">
            {{ 'header.navigation.news-and-actions' | translate | async }}
          </a>
          <a [routerLink]="langPart+'/roadmap'" routerLinkActive="active-link" (click)="closeDrawer()">
            {{ 'header.navigation.roadmap' | translate | async }}
          </a>
        </div>

      @if (!user) {
        <mat-divider></mat-divider>
        <div class="section auth">
          <a mat-button [routerLink]="langPart+'/auth/login'" aria-label="Login">
            <mat-icon>login</mat-icon>
            {{ 'header.navigation.login' | translate | async }}
          </a>
          <a mat-button [routerLink]="langPart+'/auth/register'" class="no-mobile" aria-label="Sign Up">
            <mat-icon>person_add</mat-icon>
            {{ 'header.navigation.sign-up' | translate | async }}
          </a>
        </div>
      }

    </nav>
  </mat-drawer>
</mat-drawer-container>
<!-- Mobile Menu END -->

<!-- Main Header -->
<mat-toolbar color="primary" [class.inGame]="inGame" [class.inLobby]="inLobby">
  <div class="right-side">
    @if (inGame) {
      <div class="menu-button-background"></div>
      <div class="mobile-game-header-dummy"></div>
    }
    <button mat-icon-button class="mobile-menu-button" (click)="toggleDrawer()" aria-label="Open menu">
      <mat-icon class="mobile-icon">menu</mat-icon>
    </button>
    @if (inGame) {
      <button mat-icon-button class="no-mobile reversed" (click)="onLeaveSession()">
        <mat-icon class="mobile-icon" [matTooltip]="'header.navigation.leave-game' | translate | async">exit_to_app</mat-icon>
      </button>
    }
  </div>
  <div class="brand-container">
    @if (!inGame) {
      @if (user) {
        <a [routerLink]="langPart? langPart+'/playarea' : '/playarea'" class="brand" aria-label="Home">
          <img src="assets/logo/logo-blue.svg" alt="XEDOOM" class="brand-title logo" width="140" height="28">
          <sup class="no-mobile">beta {{ version }}</sup>
        </a>
      } @else {
        <a [routerLink]="langPart? langPart : '/'" class="brand" aria-label="Home">
          <img src="assets/logo/logo-blue.svg" alt="XEDOOM" class="brand-title logo" width="140" height="28">
          <sup class="no-mobile">beta {{ version }}</sup>
        </a>
      }
    } @else {
      <!-- <div>{{ gameTitle }}</div>
      <button mat-icon-button class="no-mobile show-in-lobby" (click)="onLeaveSession()">
        <mat-icon class="mobile-icon" [matTooltip]="'header.navigation.leave-game' | translate | async">exit_to_app</mat-icon>
      </button> -->
    }
  </div>

  <div class="public-links">
    @if (fullMenu) {
      <a [routerLink]="langPart? langPart : '/'" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }">
        {{ 'header.navigation.home' | translate | async }}
      </a>
      <a [routerLink]="langPart? langPart + '/features' : '/features'" routerLinkActive="active-link">
        {{ 'header.navigation.features' | translate | async }}
      </a>
      <a [routerLink]="langPart+'/news'" routerLinkActive="active-link">
        {{ 'header.navigation.news-and-actions' | translate | async }}
      </a>
      <a [routerLink]="langPart+'/roadmap'" routerLinkActive="active-link">
        {{ 'header.navigation.roadmap' | translate | async }}
      </a>
    }
  </div>

  <!-- <span class="spacer"></span> -->

  <div class="right-menu">
    @if (user) {
      @if (dynamicItemsLoaded && !currentSessionId && !fullMenu) {
        <button mat-button class="no-laptop" (click)="openJoinGameDialog()">
          <mat-icon class="mobile-icon">group_add</mat-icon>
          <span class="no-mobile">{{ 'header.navigation.join-game' | translate | async }}</span>
        </button>
      }
      @if (dynamicItemsLoaded && joinedAsPlayer && viewerMode === true) {
        <button mat-icon-button class="no-laptop" [routerLink]="[langPart+'/playarea/room', currentSessionId]" aria-label="Game mode">
          <mat-icon class="mobile-icon" matTooltip="{{ 'header.navigation.back-to-game-mode' | translate | async}}">sports_esports</mat-icon>
        </button>
      }
      @if (dynamicItemsLoaded && joinedAsPlayer && viewerMode === false) {
        <button mat-icon-button class="no-laptop" [routerLink]="[langPart+'/playarea/room', currentSessionId, 'viewer']" aria-label="Viewer mode">
          <mat-icon class="mobile-icon" matTooltip="{{ 'header.navigation.viewer-mode' | translate | async}}">tv</mat-icon>
        </button>
        <!-- <app-hint class="no-mobile" text="{{ 'hints.viewer_mode' | translate | async}}" hintId="4" arrowPosition="top-right" left="calc(50% - 340px)" top="30px" width="300px"></app-hint> -->
      }
      @if (currentSessionId) {
        @if (!isInRoom) {
          <button mat-button [routerLink]="[langPart+'/playarea/room', currentSessionId]" class="active-game-button" aria-label="Active Game">
            <mat-icon class="mobile-icon">sports_esports</mat-icon>
            <span class="no-mobile">{{ 'header.navigation.active-game' | translate | async }}</span>
          </button>
        } @else {
          <!-- <button mat-icon-button class="no-laptop" (click)="onLeaveSession()">
            <mat-icon class="mobile-icon" [matTooltip]="'header.navigation.leave-game' | translate | async">exit_to_app</mat-icon>
          </button> -->
        }
      }
      @if (!inGame) {
        <div class="profile-menu no-laptop">
          <a mat-button [routerLink]="langPart+'/playarea'" aria-label="All Games">
            <mat-icon>games</mat-icon>
            {{ 'header.navigation.all-games' | translate | async }}
          </a>
          <button mat-button [matMenuTriggerFor]="userMenu">
            <mat-icon>account_circle</mat-icon>
            <span>{{ user.name }}</span>
          </button>
          <mat-menu #userMenu="matMenu" class="mat-menu">
            <div class="tokens">
              <mat-icon matTooltip="{{'game_tokens.tooltips.monthly_tokens' | translate | async}}" color="accent">token</mat-icon>
              <span class="value">{{(currentBalance$ | async)?.monthlyTokens}}</span>
              <mat-icon matTooltip="{{'game_tokens.tooltips.bonus_tokens' | translate | async}}" color="warn">diamond</mat-icon>
              <span class="value">{{(currentBalance$ | async)?.bonusTokens}}</span>
            </div>
            <button mat-menu-item [routerLink]="[langPart+'/profile/my-profile']">
              <mat-icon>person</mat-icon>
              {{ 'profile.menu.my_profile' | translate | async }}
            </button>
            <button mat-menu-item [routerLink]="[langPart+'/profile/my-teams']">
              <mat-icon>groups</mat-icon>
              {{ 'profile.menu.my_teams' | translate | async }}
            </button>
            <button mat-menu-item [routerLink]="[langPart+'/profile/my-games']">
              <mat-icon>videogame_asset</mat-icon>
              {{ 'profile.menu.my_games' | translate | async }}
            </button>
            <button mat-menu-item [routerLink]="[langPart+'/profile/quiz-ai']">
              <mat-icon>quiz</mat-icon>
              {{ 'header.navigation.play-ai' | translate | async }}
            </button>
            <button mat-menu-item [routerLink]="[langPart+'/profile/games-played']">
              <mat-icon>history_edu</mat-icon>
              {{ 'profile.menu.games_played' | translate | async }}
            </button>
            <button mat-menu-item (click)="onLogout()">
              <mat-icon>logout</mat-icon>
              {{ 'header.navigation.logout' | translate | async }}
            </button>
          </mat-menu>
        </div>
      }
    } @else if (dynamicItemsLoaded) {
      <a mat-button [routerLink]="langPart+'/auth/login'">
        <mat-icon>login</mat-icon>
        <span>{{ 'header.navigation.login' | translate | async }}</span>
      </a>
      <a mat-button [routerLink]="langPart+'/auth/register'" class="no-mobile">
        <mat-icon>person_add</mat-icon>
        <span>{{ 'header.navigation.sign-up' | translate | async }}</span>
      </a>
    }
    @if (!inGame) {
      <app-language-selector></app-language-selector>
    }
  </div>
</mat-toolbar>
@if (user && !isInQuizAI) {
  <app-quiz-ai-modal></app-quiz-ai-modal>
}
